import styled, { css } from 'styled-components';

import { COLOR_GRAY_90 } from 'styles/variables/colors';

export const Container = styled.nav`
  margin-bottom: 30px;
`;

export const Anchor = styled.a`
  text-decoration: underline;
  margin: 0 5px;
  cursor: pointer;
  font-weight: 600;
  background: transparent;
  font-size: 20px;
  padding: 0;
  border: 0;
  color: COLOR_PURPLE;
  text-transform: capitalize;

  &::after {
    content: '>';
    display: inline-block;
    margin-left: 10px;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    color: ${COLOR_GRAY_90};
  }

  ${(props) =>
    props.isDisabled &&
    css`
      text-decoration: none;
      cursor: initial;

      &::after {
        display: none;
      }
    `}
`;
